import { useEffect, useState } from "react";
import { API } from "@/library/lib/api";

const DEFAULTS = {
  site_name: "المكتبة الرقمية",
  school_name: "مدارس العلم النافع الأهلية",
  hero_title: "المكتبة الرقمية",
  hero_subtitle: "مدارس العلم النافع الأهلية",
  hero_description: "منصة احترافية لإدارة وأرشفة الوثائق التعليمية بشكل هرمي منظم — تجربة وصول سلسة لأي ملف في 3 إلى 4 خطوات فقط.",
  welcome_badge: "نظام أرشفة تعليمي مؤسسي رسمي",
  footer_about: "نظام أرشفة وإدارة تعليمية احترافي.",
  logo_url: "",
  credit_text: "برمجة وتصميم الأستاذ محمد كامل",
  credit_phone: "0590939015",
  contact_email: "info@madaris.edu",
};

let cache = null;

export const resolveLogoUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
};

export const useSettings = () => {
  const [settings, setSettings] = useState(cache || DEFAULTS);
  useEffect(() => {
    fetch(`${API}/settings`)
      .then((r) => r.json())
      .then((d) => { cache = { ...DEFAULTS, ...d }; setSettings(cache); })
      .catch(() => {});
  }, []);
  return settings;
};
